import { View } from 'react-native';
const ScreenContentWrapper = View;
export default ScreenContentWrapper;
//# sourceMappingURL=ScreenContentWrapper.web.js.map